export const title = 'Inicia Sesión';
export const emailLabel = 'Email';
export const emailWarning = 'Por favor ingresa un email válido';
export const passwordLabel = 'Contraseña';
export const passwordWarning = 'Por favor ingresa tu contraseña';
export const signUpLabel = '¿No tienes cuenta? ';
export const signUpButton = '¡Regístrate!';
export const logInButton = 'Ingresar';
